import React, {h} from 'preact';
import SellContactFormStep from './SellContactFormStep';

export default class SellAndBuyAddressStep extends SellContactFormStep {
    constructor(props) {
        super(props);

        const superValidateAddress = this.validateAddress;
        this.validateAddress = () => {
            this.setState({
                isValidatingAddress: true,
                addressErrorFromServer: null
            });
            superValidateAddress();
            this.validationPromise.then(validationResult => {
                if (validationResult && validationResult.msg) {
                    this.setState({addressErrorFromServer: validationResult.msg});
                }
                return validationResult;
            }).always(() => {
                this.setState({isValidatingAddress: false});
            });
        };
    }

    componentDidMount() {
        trackEvent('Flow', 'sellAndBuyRequest', this.props.buyLocationForm ? 'sellandbuyCity' : 'sellandbuyAddress')
            .withOptimizely()
            .withGA();

        if (this.refs.address) {
            this.props.parent.addressDetails = null;

            if (this.props.address) {
                $(this.refs.address).val(this.props.address);
            }

            this.props.parent.locationBiasPromise.then(locationBias => {
                const autocomplete = new google.maps.places.Autocomplete(this.refs.address, {
                    types: ['address'],
                    componentRestrictions: {country: 'us'}
                });
                autocomplete.setFields(['address_components']);
                autocomplete.addListener('place_changed', () => {
                    let place = autocomplete.getPlace();
                    let addressComponents = (place && place['address_components']) || [];
                    let addressDetails = (this.props.parent.addressDetails = {});
                    for (var i in addressComponents) {
                        let component = addressComponents[i];
                        if ($.inArray('street_number', component.types) !== -1) {
                            addressDetails.streetNumber = component['short_name'];
                        } else if ($.inArray('route', component.types) !== -1) {
                            addressDetails.street = component['short_name'];
                        } else if ($.inArray('locality', component.types) !== -1) {
                            addressDetails.city = component['long_name'];
                        } else if (
                            !addressDetails.city &&
                            $.inArray('administrative_area_level_3', component.types) !== -1
                        ) {
                            addressDetails.city = component['long_name'];
                        } else if (
                            !addressDetails.city &&
                            $.inArray('administrative_area_level_2', component.types) !== -1
                        ) {
                            addressDetails.city = component['long_name'];
                        } else if ($.inArray('administrative_area_level_1', component.types) !== -1) {
                            addressDetails.state = component['short_name'];
                        } else if ($.inArray('postal_code', component.types) !== -1) {
                            addressDetails.zip = component['short_name'];
                        } else if ($.inArray('country', component.types) !== -1) {
                            addressDetails.country = component['short_name'];
                        }
                    }
                    if (!addressDetails.streetNumber || !addressDetails.street || !addressDetails.city) {
                        addressDetails = null;
                    } else {
                        addressDetails.streetAddress = addressDetails.streetNumber + ' ' + addressDetails.street;
                        if (place.geometry && place.geometry.location) {
                            addressDetails.mapLongitude = place.geometry.location.lng();
                            addressDetails.mapLatitude = place.geometry.location.lat();
                        }
                    }
                    this.props.parent.addressDetails = addressDetails;
                    this.hasAddressBeenValidated = false;
                    this.validateAddress();
                });
                $(this.refs.address).on('change', () => {
                    this.hasAddressBeenValidated = false;
                    this.props.parent.addressDetails = null;
                    this.validateAddress();
                });
                $(this.refs.unit).on('change', () => {
                    this.hasAddressBeenValidated = false;
                    this.props.parent.addressDetails = null;
                    this.validateAddress();
                });
            });
        }

        if (this.refs.buyingArea) {
            if (!this.refs.buyingArea.value) {
                this.refs.buyingArea.value = this.props.location;
            }

            const autocompleteBuy = new google.maps.places.Autocomplete(this.refs.buyingArea, {
                types: ['(cities)'],
                componentRestrictions: {country: 'us'}
            });
            autocompleteBuy.setFields(['address_components']);
            autocompleteBuy.addListener('place_changed', () => {
                let place = autocompleteBuy.getPlace();
                let addressComponents = (place && place['address_components']) || [];
                let addressDetails = {};
                for (var i in addressComponents) {
                    let component = addressComponents[i];
                    if ($.inArray('locality', component.types) !== -1) {
                        addressDetails.city = component['long_name'];
                    } else if ($.inArray('administrative_area_level_1', component.types) !== -1) {
                        addressDetails.state = component['short_name'];
                    } else if ($.inArray('postal_code', component.types) !== -1) {
                        addressDetails.zip = component['short_name'];
                    } else if ($.inArray('country', component.types) !== -1) {
                        addressDetails.country = component['short_name'];
                    }
                }
                this.props.parent.setState({buyingArea: `${addressDetails.city}, ${addressDetails.state}`});
            });
        }

        $('#flow-container .float-label-div').initFloatLabels();

        this.validator = $(this.refs.form).validate({
            messages: {
                unit: {
                    required: 'Unit # is required.'
                }
            },
            invalidHandler: (form, validator) => {
                validator.focusInvalid();
                this.trackValidationError();
                this.notifyOnValidationErrorThrottled();
            },
            errorPlacement: (error, element) => {
                error.insertAfter(element);
                element.parent().addClass('error');
            }
        });
    }

    nextStep = throttleByPromise(() => {
        if (!$(this.refs.form).valid() || this.state.addressErrorFromServer) {
            this.trackValidationError();
            this.notifyOnValidationErrorThrottled();
            return;
        }

        if (!this.props.buyLocationForm) {
            this.validateAddress();
            this.validationPromise.then(validationResult => {
                if (validationResult && validationResult.msg) {
                    this.trackValidationError(validationResult.rejectReason || 'address');
                    this.notifyOnValidationErrorThrottled();
                    return;
                }
                this.props.parent.setState({
                    sellBuyLocationForm: true
                });
                this.props.parent.setState({currentStep: 'SELL_AND_BUY_BUY_LOCATION_STEP'});
            });
        } else {
            this.props.parent.setState({
                currentStep: 'SELL_EXPECTED_LIST_DATE',
                alsoBuying: true,
                buyingArea: this.refs.buyingArea.value,
                sellBuyLocationForm: false
            });
        }
    });

    render() {
        return (
            <div id="sell-flow-step5" className="flow-step">
                <div className="flow-step-header-text">
                    {this.props.buyLocationForm && <strong>Where do you want to buy?</strong>}
                    {!this.props.buyLocationForm && !this.props.address && (
                        <strong>
                            What’s the address of the home you want to <span className="hidden-xs">sell?</span>
                            <span className="visible-xs">SELL?</span>
                        </strong>
                    )}
                    {!this.props.buyLocationForm &&
                        !!this.props.address && [
                            <strong>Please confirm the address of the home you want to sell.</strong>,
                            <div className="flow-step-text" style="width:100%">
                                With the correct address, we can better match you with the perfect agent.
                            </div>
                        ]}
                </div>

                <form ref={elem => (this.refs.form = elem)}>
                    {this.props.buyLocationForm && (
                        <div
                            ref={elem => (this.refs.buyingAreaBlock = elem)}
                            className={`float-label-div${this.props.buyLocationForm ? '' : ' hidden'}`}
                            style={{position: 'relative'}}>
                            <input
                                className="required form-control validCityStateOrZip"
                                ref={elem => (this.refs.buyingArea = elem)}
                                id="buyingArea"
                                name="buyingArea"
                                placeholder=""
                                onBlur={() => {
                                    if ($(this.refs.buyingArea).valid()) {
                                        $(this.refs.buyingAreaBlock).removeClass('error');
                                    }
                                }}
                            />
                            <label htmlFor="buyingArea" className="float-label required">
                                City and State
                            </label>
                            <i className="contact-form-icon icon-location-outline" />
                        </div>
                    )}

                    {!this.props.buyLocationForm && (
                        <div
                            ref={elem => (this.refs.addressBlock = elem)}
                            className={`float-label-div${this.props.buyLocationForm ? ' hidden' : ''}`}
                            style={{position: 'relative'}}>
                            <input
                                className="required validStreetCityState"
                                ref={elem => (this.refs.address = elem)}
                                id="address"
                                name="address"
                                placeholder=""
                                // defaultValue={this.props.address} // doesn't work well with the autocomplete
                                autoComplete="street-address"
                                onFocus={() => {
                                    this.refs.address.setAttribute('autocomplete', 'street-address');
                                }}
                                onBlur={() => this.validateAddress()}
                            />
                            <label htmlFor="address" className="float-label required">
                                Property address
                            </label>
                            <i className="contact-form-icon icon-location-outline" />
                            {!!this.state.addressErrorFromServer &&
                                <label htmlFor="address" generated="true" className="error from-server">
                                    {this.state.addressErrorFromServer}
                                </label>
                            }
                        </div>
                    )}
                    {!this.props.buyLocationForm && (
                        ['Condominium', 'Townhouse'].includes(this.props.parent.state.homeType) ? (
                            <div className="float-label-div">
                                <input
                                    maxLength="5"
                                    ref={elem => (this.refs.unit = elem)}
                                    id="unit"
                                    name="unit"
                                    placeholder=""
                                    className={this.props.parent.state.homeType === 'Condominium' ? 'required' : ''}
                                    onBlur={() => $(this.refs.unit).valid() || this.notifyOnValidationErrorThrottled()}
                                />
                                <label
                                    htmlFor="unit"
                                    className={
                                        this.props.parent.state.homeType === 'Condominium'
                                            ? 'float-label required'
                                            : 'float-label'
                                    }>
                                    Unit #
                                </label>
                                <i className="contact-form-icon icon-menu_requests" />
                            </div>
                        ) : null
                    )}
                </form>

                <button
                    type="button"
                    className={
                        window.SPLIT_CONTACT_FORM_STEP ? 'continue-button split-contact-form-button' : 'continue-button'
                    }
                    disabled={this.state.isValidatingAddress}
                    onClick={() => this.nextStep()}>
                    Continue
                </button>

                <div className="flow-spacer" />
            </div>
        );
    }
}
